module.exports = __webpack_public_path__ + "static/media/pending-payment-mob.873aea85.svg";